import { render, staticRenderFns } from "./NestedField.vue?vue&type=template&id=00e64a2c"
import script from "./NestedField.vue?vue&type=script&lang=js"
export * from "./NestedField.vue?vue&type=script&lang=js"
import style0 from "./NestedField.vue?vue&type=style&index=0&id=00e64a2c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports